var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_vm.widget ? _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "textarea-composite-container"
  }, [_c('input-textarea', {
    ref: "description",
    attrs: {
      "required": false,
      "max-length": 255,
      "rows": 1,
      "input-id": "widget-description",
      "input-name": _vm.$t('common.target'),
      "input-placeholder": _vm.$t('collect.for.what'),
      "composite": ""
    },
    model: {
      value: _vm.widget.description,
      callback: function callback($$v) {
        _vm.$set(_vm.widget, "description", $$v);
      },
      expression: "widget.description"
    }
  }), _c('attachment-image', {
    attrs: {
      "link": _vm.widget.attachment.link,
      "input-id": "widget.attachment",
      "type": "secondary",
      "composite": "",
      "composite-textarea": ""
    },
    on: {
      "loading": _vm.onImageLoading,
      "uploaded": function uploaded(data) {
        return _vm.widget.attachment.setData(data);
      },
      "reset": function reset($event) {
        return _vm.widget.attachment.reset();
      }
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-price', {
    ref: "amountGoal",
    attrs: {
      "input-id": "amount-goal",
      "input-name": "".concat(_vm.$t('need.to.collect'), ", ").concat(_vm.currency.sign),
      "input-title": _vm.$t('enter.amount'),
      "min-value": 1,
      "currency": _vm.currency
    },
    on: {
      "change": function change($event) {
        _vm.widget.amountGoal = $event;
      }
    },
    model: {
      value: _vm.widget.amountGoal,
      callback: function callback($$v) {
        _vm.$set(_vm.widget, "amountGoal", $$v);
      },
      expression: "widget.amountGoal"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-price', {
    ref: "startFrom",
    attrs: {
      "input-id": "start-from",
      "input-name": "".concat(_vm.$t('start.from'), ", ").concat(_vm.currency.sign),
      "input-title": _vm.$t('enter.amount'),
      "min-value": 0,
      "currency": _vm.currency
    },
    on: {
      "change": function change($event) {
        _vm.widget.startFrom = $event;
      }
    },
    model: {
      value: _vm.widget.startFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.widget, "startFrom", $$v);
      },
      expression: "widget.startFrom"
    }
  })], 1)])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.proceed')) + " ")])], 1)])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }